import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "section-select_search" }
const _hoisted_2 = ["name", "type", "value", "tabindex"]
const _hoisted_3 = ["name", "type", "value", "tabindex"]
const _hoisted_4 = ["id", "onClick"]
const _hoisted_5 = {
  key: 0,
  class: "d-flex direction-column"
}
const _hoisted_6 = { class: "text-motserrat-12-light" }
const _hoisted_7 = { class: "text-motserrat-12-light" }
const _hoisted_8 = { key: 1 }

import { ref, toRefs, computed, watch } from "vue";
import { searchTextFunction } from "@/utils/search/searchText";
import { SearcInputType } from "@/store/modules/GeoPlace/type";
import { OpenGlobal } from "@/store/modules/User/type";
import { IStore } from "@/store/types/StoreType";
import { useField } from "vee-validate";
import { useStore } from "vuex";


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchComponent',
  props: {
    name: {},
    options: {},
    store: {},
    disable: { type: Boolean },
    type: {},
    error: {},
    info: { type: Boolean },
    selectCallback: {},
    noSelect: { type: Boolean },
    tabindex: {},
    maxlength: {}
  },
  setup(__props: any) {

const props = __props;


const data = toRefs(props);

const store = useStore<IStore>();
const openUserGlobal = ref(
  computed<OpenGlobal>(() => store.getters.getUserOpenElement)
);

const searchType = ref(data.options.value);
const { value, resetField } = useField(
  data.name?.value || "search-select",
  (value: string) => value
);

const close = () =>
  store.commit("updateUserOpenGlobal", {
    value: false,
    name: data.name?.value,
  });
const updateOpen = (valueOpen?: boolean) =>
  store.commit("updateUserOpenGlobal", {
    value: valueOpen || !openUserGlobal.value.value,
    name: data.name?.value,
  });

const changeDelete = (valueDelete: boolean) => (backspace.value = valueDelete);

const changeValueInSelected = (option: SearcInputType) => {
  resetField({
    value: option.value,
  });

  searchType.value = searchTextFunction(option.value, data.options.value);

  store.commit(data.store.value, searchType.value);

  if (Array.isArray(data.selectCallback.value))
    data.selectCallback.value.forEach((value) => {
      store.dispatch(value);
    });
  else if (data.selectCallback.value.length > 0)
    store.dispatch(data.selectCallback.value);
};

const updateValue = (event: Event) => {
  let value = (event.target as HTMLInputElement).value;
  if(data.maxlength?.value && value.length > data.maxlength?.value) {
    value = value.substring(0, 5);
  }
  resetField({
    value,
  });

  searchType.value = searchTextFunction(value, data.options.value);

  if (value.length <= 0) store.commit(data.store.value, null);
};

const backspace = ref(true);

watch(
  () => props.options,
  () => {
    if (props.options.length === 1 && backspace.value) {
      resetField({
        value: props.options[0].value,
      });
      store.commit(data.store.value, props.options[0]);
    } else if (data.type.value !== "number") {
      const some = props.options.some((_) => value.value.indexOf(_.value) > -1);
      if (!some || props.options.length > 1) {
        resetField({
          value: "",
        });
        store.commit(data.store.value, null);
      } else {
        resetField({
          value: props.options[0].value,
        });
        store.commit(data.store.value, props.options[0].value);
      }
    } else if (data.options.value.length === 0) {
      resetField({
        value: "",
      });
    }
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["select-form select-search b-solid-blue100", {
        'error-input country': _unref(data).error.value?.length > 0,
        'disabled-select': props.noSelect || props.options?.length <= 1,
      }]),
      onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (!props.noSelect && updateOpen(true)), ["stop"]))
    }, [
      (_ctx.disable)
        ? (_openBlock(), _createElementBlock("p", {
            key: 0,
            class: _normalizeClass(["text-motserrat-16 text-nowrap pointer", { 'disabled-select': props.noSelect || props.options?.length <= 1 }])
          }, _toDisplayString(_unref(value)), 3))
        : ((_unref(data).type.value === 'number' && _unref(data).maxlength?.value === 5))
          ? (_openBlock(), _createElementBlock("input", {
              key: 1,
              name: _unref(data).name.value,
              max: 99999,
              type: _unref(data).type.value,
              onKeyup: _cache[0] || (_cache[0] = _withKeys(($event: any) => (changeDelete(false)), ["delete"])),
              class: "text-motserrat-16",
              value: _unref(value),
              tabindex: _unref(data).tabindex.value,
              onInput: updateValue,
              onFocus: _cache[1] || (_cache[1] = ($event: any) => (updateOpen(true)))
            }, null, 40, _hoisted_2))
          : (_openBlock(), _createElementBlock("input", {
              key: 2,
              name: _unref(data).name.value,
              maxlength: 55,
              type: _unref(data).type.value,
              onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (changeDelete(false)), ["delete"])),
              class: "text-motserrat-16",
              value: _unref(value),
              tabindex: _unref(data).tabindex.value,
              onInput: updateValue,
              onFocus: _cache[3] || (_cache[3] = ($event: any) => (updateOpen(true)))
            }, null, 40, _hoisted_3)),
      _createElementVNode("ul", {
        class: _normalizeClass(["list", {
          hidden:
            !openUserGlobal.value.value || openUserGlobal.value.name !== _unref(data).name?.value || props.options?.length <= 1,
          open:
            openUserGlobal.value.value || openUserGlobal.value.name === _unref(data).name?.value,
        }])
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).options.value, (option, i) => {
          return (_openBlock(), _createElementBlock("div", {
            key: option.id + i || i,
            class: "w-100",
            onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (close()), ["stop"]))
          }, [
            _createElementVNode("li", {
              id: _unref(data).name.value + '_li',
              class: "list-item text-motserrat-16",
              onClick: _withModifiers(($event: any) => (changeValueInSelected(option), updateOpen(false)), ["stop"])
            }, [
              (_unref(data).info.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("span", _hoisted_6, _toDisplayString(option.data.geo_name), 1),
                    _createElementVNode("span", _hoisted_7, _toDisplayString(option.value), 1)
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(option.value), 1))
            ], 8, _hoisted_4)
          ]))
        }), 128))
      ], 2)
    ], 2)
  ]))
}
}

})